export const TOGGLE_AUTOMATION_VISIBILITY = 'change automation field visibility';

export const updateAutomationVisibility = (data) => ({
  payload: data,
  type: TOGGLE_AUTOMATION_VISIBILITY
});
